// extracted by mini-css-extract-plugin
export default {"admin_content_area":"termsAndCondition_admin_content_area__pViRE","modal_root":"termsAndCondition_modal_root__jqTM4"};